'use strict'

Vue.component('awe-filters', {
  props:{
    wtbid: {type: String},
    country:{type: String},
    lang: {type: String, default: 'en'},
    cascading: {type: Boolean, default: false}, // Whether facets are linked or independant
    openFacets: {type: Array, default: () => {return []}}, // Facets to open by default
    ready: {type: Boolean, default: false},
  },

  data: function(){
    return {
      i18n: this.$root.i18n,
    }
  },

  methods:{
    getSelectionLength(filters) {
      return filters?.[1]?.length || 0;
    },
    applySelection(selection) {
      this.$emit('filter-selection-update', selection);
    },
  },
  template: `
  <awe-facets-logic
    :wtbid="wtbid" :country="country" :lang="lang" 
    :cascading="false"
    :set-default-filters="false"
    :multiSelect="true"
    v-slot="{facets, eans, defaultEan, updateFacets, filters, clearAllFilters}"
    ref="filters"
    :ready="ready"
  >
    <div class="filters-container">
      <slot name="title" />
      <button 
        class="clear-link" 
        @click="clearAllFilters"
        :aria-label="i18n.getString('CLEAR_FILTERS')"
      >
       {{ i18n.getString('CLEAR_FILTERS') }}
      </button>
      <div class="accordion-container">
        <div v-for="(facet, idx) in facets" class="facet">
          <awe-accordion
           :aria-label="facet.name || facet.key"
           :default-open="openFacets.includes(facet.key)"
          >
            <template #title>
              {{ facet.name || facet.key }}
              <div class="badge" v-show="getSelectionLength(filters[idx])">
                {{ getSelectionLength(filters[idx]) }}
              </div>
            </template>
            <template #content>
              <awe-list
                :items="facet.values"
                type="checkbox"
                v-on:change="updateFacets($event, idx)"
              />
            </template>
          </awe-accordion>
          <hr class="filters-break">
        </div>
      </div>
      <button
        class="apply-button"
        @click="applySelection(filters)"
        :aria-label="i18n.getString('APPLY_FILTERS')"
      >
        {{ i18n.getString('APPLY_FILTERS') }}
      </button>
    </div>
  </awe-facets-logic>
  `
})
